export const TERMS_OF_USE_LINK = 'https://app.prisma-ai.com/terms_of_service.html'
export const PRIVACY_POLICY_LINK = 'https://app.prisma-ai.com/privacy_policy.html'

export const WEB_PRIVACY_LINK = 'https://prisma-ai.com/web-privacy'
